import { useCallback } from 'react';
import logger from 'ws-scripts/modules/logger';

const useErrorHandler = (setHasError, setIsLoading, logMessage) =>
	useCallback(() => {
		logger.error(logMessage);
		setHasError(true);
		setIsLoading(false);
	}, [setHasError, setIsLoading, logMessage]);

export default useErrorHandler;
